<main class="container layout-39">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>
  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <h1>AI Config - Connections</h1>

        <!-- Success/Error Messages -->
        @if (successMessage) {
<div class="alert alert-success">
          <mat-icon>check_circle</mat-icon>
          {{ successMessage }}
        </div>
}

        @if (error) {
<div class="alert alert-danger">
          <mat-icon>error_outline</mat-icon>
          {{ error }}
        </div>
}

        @if (loading) {
      <app-ai-connections-skeleton></app-ai-connections-skeleton>
      }

        @if (!loading) {
<div style="padding: 20px 0;">
          <p class="text-muted">
            Manage Microsoft Foundry model connections and approved Chevron APIM gateway base URLs. All connections authenticate with Microsoft Entra ID.
          </p>

          <button type="button" class="btn btn-primary no-arrow" (click)="startCreateConnection()" 
                  [disabled]="editingConnection !== null" style="margin-bottom: 20px;">
            Add New Connection
          </button>

          <!-- Connection List as Table -->
          @if (connections.length > 0 && !editingConnection) {
<div class="card" style="margin-bottom: 20px;">
            <div class="card-body">
              <h5>Configured Connections</h5>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Endpoint</th>
                    <th>Model</th>
                    <th>Deployment</th>
                    <th>API Version</th>
                      <th>API Mode</th>
                      <th>Reasoning Effort</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (connection of connections; track connection) {
<tr>
                    <td>{{ connection.name }}</td>
                    <td>{{ connection.endpoint }}</td>
                    <td>{{ connection.modelName }}</td>
                    <td>{{ connection.deployment }}</td>
                    <td>{{ connection.apiVersion }}</td>
                    <td>{{ connection.apiMode ? connection.apiMode : 'ChatCompletions' }}</td>
                    <td>{{ connection.reasoningEffort === null || connection.reasoningEffort === undefined ? 'Auto' : connection.reasoningEffort }}</td>
                    <td>
                      <div style="display: flex; gap: 5px;">
                        <button type="button" class="btn btn-sm btn-secondary no-arrow" 
                                (click)="editConnection(connection)"
                                [disabled]="editingConnection !== null">
                          edit
                        </button>
                        <button type="button" class="btn btn-sm btn-danger no-arrow" 
                                (click)="deleteConnection(connection)"
                                [disabled]="saving">
                         delete
                        </button>
                      </div>
                    </td>
                  </tr>
}
                </tbody>
              </table>
            </div>
          </div>
}

          @if (connections.length === 0 && !editingConnection) {
<div class="alert alert-info">
            No connections configured. Click "Add New Connection" to create one.
          </div>
}

          <!-- Connection Edit Form -->
          @if (editingConnection) {
<div class="card" style="margin-bottom: 20px;">
            <div class="card-body">
              <h5>{{ isCreatingConnection ? 'Create New Connection' : 'Edit Connection' }}</h5>

              <div class="form-group">
                <label>Connection Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="editingConnection.name"
                       placeholder="e.g., Chevron Production GPT-6.1 Sol" [ngModelOptions]="{standalone: true}">
              </div>

              <div class="form-group">
                <label>Endpoint URL <span class="text-danger">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="editingConnection.endpoint"
                       placeholder="https://apim.chevron.com/ai-models/ai-realtime-inference-p101/v1" [ngModelOptions]="{standalone: true}">
                      <small class="form-text text-muted">Supported: direct Microsoft Foundry endpoints on <em>.services.ai.azure.com</em> or Chevron APIM gateway base URLs on <em>apim.chevron.com</em> with path <code>/ai-models/ai-realtime-inference-&lt;id&gt;/v1/</code>. No username/password, query, fragment, or non-default ports.</small>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Model Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="editingConnection.modelName"
                           placeholder="e.g., gpt-6.1-sol" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Deployment Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="editingConnection.deployment"
                           placeholder="e.g., gpt-6_1-sol-gs-2026-09-29" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>API Version <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="editingConnection.apiVersion"
                           placeholder="v1" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>API Mode</label>
                    <select class="form-control" [(ngModel)]="editingConnection.apiMode" [ngModelOptions]="{standalone: true}">
                      <option value="Responses">Responses</option>
                      <option value="ChatCompletions">Chat Completions</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Reasoning Effort</label>
                    <select class="form-control" [(ngModel)]="editingConnection.reasoningEffort" [ngModelOptions]="{standalone: true}">
                      <option [ngValue]="null">Auto</option>
                      <option value="low">low</option>
                      <option value="medium">medium</option>
                      <option value="high">high</option>
                      <option value="xhigh">xhigh</option>
                    </select>
                  </div>
                </div>
              </div>

              <p class="text-muted">
                Authentication is Microsoft Entra ID using an application service principal or managed identity,
                not the signed-in user's account.
                Gateway access must be approved for the calling identity. Direct Foundry access requires the
                "Cognitive Services OpenAI User" role. All model calls use the v1 API.
              </p>

              <div class="form-group">
                <label>Max Completion Tokens</label>
                <input type="number" class="form-control" [(ngModel)]="editingConnection.maxCompletionTokens"
                       [ngModelOptions]="{standalone: true}">
              </div>

              <div style="display: flex; justify-content: space-between;">
                <button type="button" class="btn btn-primary no-arrow" (click)="saveConnection()" [disabled]="saving">
                  @if (saving) {
<mat-spinner diameter="20" style="display: inline-block; margin-right: 5px;"></mat-spinner>
}
                  {{ saving ? 'Saving...' : 'Save Connection' }}
                </button>
                <button type="button" class="btn btn-secondary no-arrow" (click)="cancelEditConnection()" [disabled]="saving">
                  Cancel
                </button>
              </div>
            </div>
          </div>
}
        </div>
}
      </div>
    </div>
  </section>
</main>
